import { render, staticRenderFns } from "./WorkspaceStatusImage.vue?vue&type=template&id=8bf1a9c8"
import script from "./WorkspaceStatusImage.vue?vue&type=script&lang=ts"
export * from "./WorkspaceStatusImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports